import type { ReactNode } from 'react'

export interface ScreenHeaderProps {
  title: string
  description?: string
  actions?: ReactNode
}

export function ScreenHeader({ title, description, actions }: ScreenHeaderProps) {
  return (
    <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="font-display text-2xl font-semibold tracking-tight text-ink">{title}</h2>
        {description ? <p className="mt-0.5 text-data text-ink-muted">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  )
}
